import React from 'react';
import ReactDOM from 'react-dom/client';
import { ApolloProvider } from '@apollo/client';
import { ConfigProvider } from 'antd';
import locale from 'antd/es/locale/pt_BR';
import dayjs from 'dayjs';
import 'dayjs/locale/pt-br';
import client from './apolloClient';
import App from './App';
import theme from './theme';
// import './index.css';

// Configurar dayjs globalmente para português
dayjs.locale('pt-br');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ApolloProvider client={client}>
    <ConfigProvider theme={theme} locale={locale}>
      <App />
    </ConfigProvider>
  </ApolloProvider>
);